var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCameraPurple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "19px",
    viewBox: "0 0 27 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCameraPurple") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Customised-Themes",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messenger---dark-purple",
    transform: "translate(-306.000000, -79.000000)",
    fill: "#9932CC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.412219,15.5490263 C332.281659,15.4996347 332.156113,15.4748349 332.035475,15.4748349 C331.764224,15.4748349 331.538462,15.5690428 331.357505,15.7569388 L325.285488,21.7242719 L325.285488,19.2750741 C325.285488,18.0973192 324.861091,17.0905631 324.012296,16.2542858 C323.163449,15.4181126 322.141665,15 320.946102,15 L310.339175,15 C309.143981,15 308.121881,15.4181126 307.272981,16.2542858 C306.424397,17.0905631 306,18.0973192 306,19.2750741 L306,29.7250819 C306,30.9027328 306.424397,31.9094369 307.273034,32.7456622 C308.121934,33.5818874 309.144034,34 310.339228,34 L320.946207,34 C322.141718,34 323.163554,33.5818874 324.012402,32.7456622 C324.861196,31.9094369 325.285594,30.9027848 325.285594,29.7250819 L325.285594,27.2608586 L331.357611,33.2430092 C331.538568,33.4308532 331.764329,33.5250091 332.03558,33.5250091 C332.156219,33.5250091 332.281765,33.5002613 332.412324,33.4509737 C332.804266,33.2826785 333,32.9908523 333,32.5752353 L333,16.4250247 C333,16.0091997 332.804108,15.7173215 332.412219,15.5490263 Z",
    id: "icCameraPurple"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCameraPurple);
export default __webpack_public_path__ + "static/media/icCameraPurple.451df3a93adb0e0cefb3ba2035fcba7b.svg";
export { ForwardRef as ReactComponent };